module.exports = __webpack_public_path__ + "static/media/nav-icon-role-relation-inactive.49cc8cc4.svg";